export interface TempDataState {
	isUnauthorizedUser?: boolean;
	hideCoachMarks?: boolean;
}

export const tempDataActions = {
	saveTempData: '@tempData/saveTempData',
};
